(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-cart-note"] && !Shopify.designMode) return;
  try {
    class DSCartNoteComponent extends HTMLElement {
        connectedCallback() {
            this.dialog = this.querySelector('[data-note-dialog]');
            this.textarea = this.querySelector('[data-note-textarea]');
            this.submitButton = this.querySelector('[data-note-submit]');

            this.querySelector('[data-note-toggle]')?.addEventListener('click', () => this.open());
            this.querySelector('[data-note-close]')?.addEventListener('click', () => this.dialog.close());
            this.querySelector('[data-note-form]')?.addEventListener('submit', (e) => this.handleSubmit(e));

            // Close when clicking the backdrop
            this.dialog.addEventListener('click', (e) => {
                if (e.target === this.dialog) this.dialog.close();
            });

            // Move dialog to <body> so showModal() doesn't trigger
            // scroll adjustments inside the cart drawer
            document.body.appendChild(this.dialog);

            this.dialog.addEventListener('close', () => {
                this.dialog.style.bottom = '';
                window.visualViewport?.removeEventListener('resize', this._vpListener);
                window.visualViewport?.removeEventListener('scroll', this._vpListener);
            });
        }

        disconnectedCallback() {
            this.dialog?.remove();
        }

        open() {
            this.updateDialogPosition();
            this.dialog.showModal();
            this.textarea?.focus({ preventScroll: true });

            this._vpListener = () => this._adjustForKeyboard();
            window.visualViewport?.addEventListener('resize', this._vpListener);
            window.visualViewport?.addEventListener('scroll', this._vpListener);
        }

        _adjustForKeyboard() {
            const vv = window.visualViewport;
            if (!vv) return;
            const keyboardHeight = window.innerHeight - vv.height - vv.offsetTop;
            this.dialog.style.bottom = `${Math.max(0, keyboardHeight)}px`;
        }

        updateDialogPosition() {
            const drawer = document.querySelector('.ds-drawer__inner');
            if (!drawer) return;
            const { left, width } = drawer.getBoundingClientRect();
            this.dialog.style.setProperty('--note-dialog-left', `${left}px`);
            this.dialog.style.setProperty('--note-dialog-width', `${width}px`);

            // Copy CSS custom properties since the dialog is no longer a DOM child of the drawer
            const drawerEl = document.querySelector('ds-cart-drawer');
            if (drawerEl) {
                const style = getComputedStyle(drawerEl);
                for (const prop of [
                    '--drawer-background-color',
                    '--cart-border-radius',
                    '--button-primary-color',
                    '--button-secondary-color',
                ]) {
                    this.dialog.style.setProperty(prop, style.getPropertyValue(prop));
                }
            }
        }

        async handleSubmit(e) {
            e.preventDefault();

            const noteValue = this.textarea?.value ?? '';

            this.submitButton?.classList.add('is-loading');

            try {
                if (window.liquidAjaxCart) {
                    await window.liquidAjaxCart.update({ note: noteValue });
                } else {
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ note: noteValue }),
                    });
                }
                this.dialog.close();
            } catch (error) {
                console.error('Cart note update error:', error);
            } finally {
                this.submitButton?.classList.remove('is-loading');
            }
        }
    }

    if (!customElements.get('ds-cart-note-component')) {
        customElements.define('ds-cart-note-component', DSCartNoteComponent);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-siblings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-siblings')) {
        customElements.define(
            'product-siblings',
            class ProductSiblings extends HTMLElement {
                connectedCallback() {
                    this.addEventListener('change', this.onChange.bind(this));
                }

                onChange(event) {
                    const input = event.target;
                    if (!input.matches('input[type="radio"]')) return;
                    const url = input.dataset.productUrl;
                    if (url) this.navigate(url);
                }

                async navigate(url) {
                    this.setAttribute('aria-busy', 'true');
                    try {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.status);

                        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
                        const newMain = doc.getElementById('MainContent');
                        const curMain = document.getElementById('MainContent');
                        if (!newMain || !curMain) {
                            window.location.assign(url);
                            return;
                        }

                        if (doc.title) document.title = doc.title;
                        window.history.pushState({}, '', url);

                        const newProductSection = this.productSection(newMain);
                        const curProductSection = this.productSection(curMain);

                        if (!newProductSection || !curProductSection) {
                            this.swapAll(curMain, newMain, doc);
                            return;
                        }

                        const liveProductSection = document.importNode(newProductSection, true);
                        curProductSection.replaceWith(liveProductSection);
                        this.runScripts(liveProductSection);

                        this.swapSection(doc, 'shopify-section-sticky-atc-bar');

                        requestAnimationFrame(() => this.renderRest(curMain, newMain, liveProductSection));
                    } catch (error) {
                        window.location.assign(url);
                    } finally {
                        this.removeAttribute('aria-busy');
                    }
                }

                productSection(root) {
                    const info = root.querySelector('product-info');
                    if (!info) return null;
                    return info.closest('[id^="shopify-section"]') || info.parentElement;
                }

                swapSection(doc, id) {
                    const current = document.getElementById(id);
                    const next = doc.getElementById(id);
                    if (!current || !next) return;
                    const adopted = document.importNode(next, true);
                    current.replaceWith(adopted);
                    this.runScripts(adopted);
                }

                renderRest(curMain, newMain, liveProductSection) {
                    const newChildren = Array.from(newMain.children);
                    const mainIndex = newChildren.findIndex((child) => child.querySelector('product-info'));
                    if (mainIndex === -1) return;

                    Array.from(curMain.children).forEach((child) => {
                        if (child !== liveProductSection) child.remove();
                    });

                    for (let i = 0; i < mainIndex; i += 1) {
                        const node = document.importNode(newChildren[i], true);
                        curMain.insertBefore(node, liveProductSection);
                        this.runScripts(node);
                    }

                    let reference = liveProductSection.nextSibling;
                    for (let i = mainIndex + 1; i < newChildren.length; i += 1) {
                        const node = document.importNode(newChildren[i], true);
                        curMain.insertBefore(node, reference);
                        this.runScripts(node);
                    }
                }

                swapAll(curMain, newMain, doc) {
                    const fragment = document.createDocumentFragment();
                    Array.from(newMain.children).forEach((child) => {
                        fragment.appendChild(document.importNode(child, true));
                    });
                    curMain.replaceChildren(fragment);
                    this.runScripts(curMain);
                    this.swapSection(doc, 'shopify-section-sticky-atc-bar');
                }

                runScripts(root) {
                    root.querySelectorAll('script').forEach((oldScript) => {
                        const type = oldScript.getAttribute('type');
                        if (type === 'application/json') return;

                        if (oldScript.src) {
                            const selector = 'script[src="' + oldScript.getAttribute('src') + '"]';
                            if (document.querySelector(selector)) return;
                            const loader = document.createElement('script');
                            Array.from(oldScript.attributes).forEach((attr) =>
                                loader.setAttribute(attr.name, attr.value)
                            );
                            document.head.appendChild(loader);
                            return;
                        }

                        const inline = document.createElement('script');
                        if (type) inline.type = type;
                        inline.textContent = oldScript.textContent;
                        oldScript.replaceWith(inline);
                    });
                }
            }
        );
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-fade-container"] && !Shopify.designMode) return;
  try {
    class ScrollFadeContainer extends HTMLElement {
        connectedCallback() {
            this.checkScroll = this.checkScroll.bind(this);
            this.addEventListener('scroll', this.checkScroll);

            this.overlay = document.createElement('span');
            this.overlay.className = 'scroll-overlay';
            this.appendChild(this.overlay);

            this.hint = document.createElement('span');
            this.hint.className = 'scroll-hint';
            this.hint.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
            this.appendChild(this.hint);

            if (typeof ResizeObserver !== 'undefined') {
                this.resizeObserver = new ResizeObserver(() => this.checkScroll());
                this.resizeObserver.observe(this);
            }

            this.checkScroll();
        }

        disconnectedCallback() {
            this.removeEventListener('scroll', this.checkScroll);
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        }

        checkScroll() {
            const canScroll = this.scrollWidth > this.clientWidth + 1;
            const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;

            this.toggleAttribute('data-can-scroll', canScroll);
            this.toggleAttribute('data-scrolled-end', atEnd);

            const rightEdge = this.scrollLeft + this.clientWidth;

            if (this.overlay) {
                this.overlay.style.left = (rightEdge - 60) + 'px';
            }

            if (this.hint) {
                this.hint.style.left = (rightEdge - 28) + 'px';
                this.hint.style.top = '50%';
            }
        }
    }

    if (!customElements.get('scroll-fade-container')) {
        customElements.define('scroll-fade-container', ScrollFadeContainer);
    }
  } catch(e) { console.error(e); }
})();

})();
